import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom';
import ImageGallery from '../components/layout/ImageGallery';
import RelatedCard from '../components/RelatedCard';
import ProductContext from '../context/products/ProductContext'
import Spinner from '../components/layout/Spinner'
import ProductNotFound from '../components/layout/ProductNotFound';
import ScrollToTop from '../components/ScrollToTop'
import { Helmet } from 'react-helmet';
import { trackAddToCart } from '../utils/pixel.jsx';


function Additive() {
    const { additive,
        loading,
        relatedProducts,
        fetchAdditive,
        fetchRelatedProducts,
        addToCart } = useContext(ProductContext)

    const [characteristisArray, setCharacteristicsArray] = useState([]);
    const [applicationsArray, setApplicationsArray] = useState([]);
    const [useArray, setUseArray] = useState([]);
    const [quantity, setQuantity] = useState(additive.stock <= 0 ? 0 : 1);
    const initialStock = additive.stock && !isNaN(additive.stock) ? additive.stock : 0;

    const { id } = useParams();
    useEffect(() => {
        if (id) {
            fetchAdditive(id); // Повикај ја функцијата ако id е валиден
            fetchRelatedProducts(); // Повикај ја функцијата за поврзани продукти
        }
    }, [id]);

    useEffect(() => {
        if (Object.keys(additive).length !== 0) {
            const additivesCharacteristicsArray = additive.characteristics
                .split(';') // Podeli string na delove na osnovu karaktera ";"
                .map(s => s.trim()) // Ukloni prazne razmake sa početka i kraja svakog dela
                .filter(s => s.length > 0); // Filtriraj prazne stringove
            setCharacteristicsArray(additivesCharacteristicsArray)

            const additivesApplicationArray = additive.application
                .split(';') // Podeli string na delove na osnovu karaktera ";"
                .map(s => s.trim()) // Ukloni prazne razmake sa početka i kraja svakog dela
                .filter(s => s.length > 0); // Filtriraj prazne stringove
            setApplicationsArray(additivesApplicationArray)

            const additivesUseArray = additive.use
                .split(';') // Podeli string na delove na osnovu karaktera ";"
                .map(s => s.trim()) // Ukloni prazne razmake sa početka i kraja svakog dela
                .filter(s => s.length > 0); // Filtriraj prazne stringove
            setUseArray(additivesUseArray)
        }

    }, [additive])


    // Прилагодување на количината кога корисникот внесува вредност
    const handleInput = (e) => {
        let value = parseInt(e.target.value);

        // Проверка дали value е NaN
        if (isNaN(value) || value <= 0) {
            value = 1;
        }

        // Ако е поголемо од stock, го поставуваме на максималниот број
        if (value > initialStock) {
            value = initialStock;
        }

        setQuantity(value);
    };

    // Кога корисникот кликне на стрелката за зголемување или намалување
    const handleButtonClick = (action) => {
        setQuantity((prevQuantity) => {
            if (action === 'increment' && prevQuantity < additive.stock) {
                return prevQuantity + 1;
            } else if (action === 'decrement' && prevQuantity > 1) {
                return prevQuantity - 1;
            }
            return prevQuantity;
        });
    };

    const pageTitle = `${additive.title} | Адитив за гориво`;
    const pageDescription = `Купете ${additive.title} адитив. Најдете го со најдобра цена на нашата онлајн продавница.`;
    const pageKeywords = `${additive.title}, ${additive.manufacturer}, адитив за гориво, адитиви, адитив`;

    if (loading) {
        return <Spinner />; // Прикажи некој индикатор додека не се наполни selectedOil
    }

    if (!additive && !loading) {
        return <ProductNotFound />
    }

    return (
        <>
            <ScrollToTop />

            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <meta name="keywords" content={pageKeywords} />
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={additive.imageUrl} /> {/* You can dynamically set image URL */}
                <meta property="og:type" content="product" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:image" content={additive.imageUrl} />
            </Helmet>

            <div className="container mx-auto p-4">
                <h1 className="text-3xl font-bold mb-4">{additive.title}</h1>
                <div className="flex flex-col md:flex-row gap-6">
                    <div className="md:w-1/3">
                        {additive && Object.keys(additive).length > 0 && (
                            <ImageGallery key={additive.id} item={additive} />
                        )}
                    </div>
                    <div className="flex-1">
                        <p className="font-semibold mb-2 text-lg">Карактеристики:</p>
                        <ul className="list-disc list-inside mb-4 text-sm">
                            {characteristisArray && (
                                characteristisArray.map((char, index) => {
                                    return <li key={index}>{char}</li>
                                })

                            )}
                        </ul>
                        {applicationsArray.length >= 1 && (<>
                            <p className="font-semibold mb-2 text-lg">Примена:</p>
                            <ul className="list-disc list-inside mb-4 text-sm">
                                {applicationsArray && (
                                    applicationsArray.map((char, index) => {
                                        return <li key={index}>{char}</li>
                                    })

                                )}
                            </ul>
                        </>)}

                        <p className="text-2xl text-red-600 font-semibold mb-4">{additive.price} ден</p>
                        <div className="flex items-center space-x-4">
                            <div className="py-2 px-3 inline-block bg-white border border-gray-200 rounded-lg dark:bg-neutral-900 dark:border-neutral-700">
                                <div className="flex items-center gap-x-1.5">
                                    {/* Намалување на вредноста */}
                                    <button
                                        type="button"
                                        className="inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:ring-neutral-600"
                                        tabIndex="-1"
                                        aria-label="Decrease"
                                        onClick={() => handleButtonClick('decrement')}
                                        disabled={additive.stock == 0}
                                    >
                                        <svg className="shrink-0 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M5 12h14"></path>
                                        </svg>
                                    </button>
                                    {/* Внесување на количина */}
                                    <input
                                        id="quantity"
                                        type="number"
                                        className="p-0 w-8 bg-transparent border-0 text-gray-800 text-center focus:ring-0 dark:text-white"
                                        style={{
                                            MozAppearance: 'textfield',
                                            WebkitAppearance: 'none',
                                        }}
                                        value={quantity}
                                        onInput={handleInput}
                                        min={1}
                                        max={additive.stock}
                                        disabled={additive.stock == 0}
                                    />
                                    {/* Зголемување на вредноста */}
                                    <button
                                        type="button"
                                        className="inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-md border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-white dark:hover:bg-neutral-800 dark:focus:ring-neutral-600"
                                        tabIndex="-1"
                                        aria-label="Increase"
                                        onClick={() => handleButtonClick('increment')}
                                        disabled={additive.stock == 0}
                                    >
                                        <svg className="shrink-0 w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M5 12h14"></path>
                                            <path d="M12 5v14"></path>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div>
                                <button className="btn btn-secondary btn-sm text-gray-300" disabled={additive.stock <= 0} onClick={() => {addToCart(additive, quantity); trackAddToCart(additive.title, additive.price)}}>{additive.stock <= 0 ? (<span>Нема залиха</span>) : (<span>Додади во кошничка</span>)}</button>
                            </div>
                        </div>
                    </div>
                    <div className="flex-1">
                        <p className="font-semibold mb-2 text-lg">Упатство:</p>
                        <ul className="list-disc list-inside mb-4 text-sm">
                            {useArray && (
                                useArray.map((char, index) => {
                                    return <li key={index}>{char}</li>
                                })

                            )}
                        </ul>
                    </div>
                </div>
                <div>
                    <h2 className='text-2xl font-bold mt-[10%] text-center mb-10'>Поврзани производи</h2>
                    <div
                        // className={`grid gap-4 mt-[5%] justify-center items-center text-xl grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4`}
                        className='flex flex-wrap gap-12 justify-center'
                    >
                        {!relatedProducts || relatedProducts.length === 0 ? (
                            <p>Нема поврзани производи за прикажување</p>
                        ) : relatedProducts.map((prod) => (
                            <div key={prod.id}>
                                <RelatedCard key={prod.id} item={prod} />
                            </div>
                        ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Additive
